import { amazonPath } from '@/helpers/FileHelper';

const storageOrigin = new URL(amazonPath).origin;

export const isStorageUrl = (src?: string): src is string => !!src && src.startsWith(storageOrigin);

export default function storageImageCrossOrigin(src?: string): 'anonymous' | undefined {
	return isStorageUrl(src) ? 'anonymous' : undefined;
}

/**
 * Adresse réservée aux chargements AVEC CORS : le stockage ne renvoie pas `Vary: Origin` et se met
 * en cache un mois, une réponse obtenue sans CORS pour la même adresse ferait échouer les suivantes.
 * Ne jamais la donner à un chargement sans CORS, comme l'`Image` d'antd, qui vérifie chaque image avec
 * une copie sans `crossOrigin`. `cors2` : l'ancienne clé `cors` a pu être empoisonnée.
 */
export function corsImageSrc<T extends string | undefined>(src: T): T {
	if (!isStorageUrl(src) || /[?&]cache=cors2(&|$)/.test(src)) return src;

	return `${src}${src.includes('?') ? '&' : '?'}cache=cors2` as T;
}
